import { render } from "./belong.vue?vue&type=template&id=36292e5c&scoped=true"
const script = {}

import "./belong.vue?vue&type=style&index=0&id=36292e5c&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36292e5c"]])

export default __exports__